import React, {useContext} from 'react';
import classes from './SortComponent.module.scss'
import {FormattedMessage} from "react-intl";
import {Context} from "../../../context/Wrapper";
import {LANG_EN} from "../../../constants";

const SortComponent = (props) => {
    const context = useContext(Context)

    return (
        <div className={classes.SortComponent_container}>
            <div>
                <FormattedMessage id={"global.sorting.sortby"} defaultMessage={"sort by"}/>
            </div>
            <select className={['jbfs-select'].join(' ')}
                    value={props.defaultOps}
                    onChange={(event) => props.onSortHandler(event)}>
                {props.options.map((option, index) => {
                    return <option key={index} value={option.value}>{context.locale === LANG_EN ? option.displayValue : option.displayId}</option>
                })}
            </select>
        </div>
    );
}

export default SortComponent;